/* eslint-disable react/prop-types */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ComparisonTable, { COMPARISON_TABLE_FEATURES_TYPES, PLAN_ID_TO_KEY } from '../../ComparisonTable';

const ComparisonTableLegacyPlans = ({ planBlocks, isUpdatingCurrency = false, showDecimals = true }) => {
  const { t } = useTranslation();

  const plans = useMemo(() => {
    // we expect only two plans here: current and recommended
    if (planBlocks?.length !== 2) return [];

    const createPlanObject = ({
      planCurrency,
      planNameId,
      planNameLabel,
      isSelected,
      isRecommended,
      isCurrent,
      planFullPrice,
      planPriceDiscounted = null,
      buttonDisabled,
    }) => {
      const createButtonLabel = () => {
        let btnText = '';

        if (isCurrent) {
          btnText = 'current_plan';
        } else if (isSelected) {
          btnText = 'button_selected_plan';
        } else {
          throw new Error('Expected plan to be either current or selected');
        }

        return t(`comparison-table.plan_blocks.${btnText}`);
      };

      return {
        planNameId,
        planNameLabel,
        isSelected,
        isRecommended,
        isCurrent,
        price: {
          paymentPeriodLabel: t('comparison-table.per-month'),
          planCurrency,
          planFullPrice,
          planPriceDiscounted,
          isUpdatingCurrency,
          showDecimals,
        },
        buttonLabel: createButtonLabel(),
        buttonClickHandler: () => {}, // noop
        buttonDisabled,
        buttonHidden: false,
      };
    };

    const fromPlanBlock = planBlocks[0].planBlockInfo;
    const from = createPlanObject({
      planCurrency: fromPlanBlock.planCurrency,
      planNameId: PLAN_ID_TO_KEY[fromPlanBlock.planId],
      planNameLabel: fromPlanBlock.planName,
      planFullPrice: fromPlanBlock.discount ?? fromPlanBlock.planPrice,
      planPriceDiscounted: fromPlanBlock.discount ? fromPlanBlock.planPrice : null,
      isSelected: false,
      isRecommended: false,
      isCurrent: true,
      buttonDisabled: true,
    });

    const toPlanBlock = planBlocks[1].planBlockInfo;
    const to = createPlanObject({
      planCurrency: toPlanBlock.planCurrency,
      planNameId: PLAN_ID_TO_KEY[toPlanBlock.planId],
      planNameLabel: toPlanBlock.planName,
      planFullPrice: toPlanBlock.discount ?? toPlanBlock.planPrice,
      planPriceDiscounted: toPlanBlock.discount ? toPlanBlock.planPrice : null,
      isSelected: true,
      isRecommended: true,
      isCurrent: false,
      buttonDisabled: false,
    });

    return [from, to];
  }, [isUpdatingCurrency, showDecimals, planBlocks]);

  if (plans.length === 0) return null;

  return (
    <ComparisonTable
      plans={plans}
      featuresType={COMPARISON_TABLE_FEATURES_TYPES.LEGACY}
      withScrollIntoViewButton
      scrollIntoViewButtonLabel={t('upgrade-popup.compare-two-plans', {
        fromPlanName: plans[0]?.planNameLabel,
        toPlanName: plans[1]?.planNameLabel,
      })}
    />
  );
};

export default ComparisonTableLegacyPlans;
